import PropTypes from "prop-types";
import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";
import { Text } from "@/component-library/Text";
import { TwoButtonCard } from "@/component-library/TwoButtonCard";

import "./styles.scss";

export const GuidedSessionReconnect = ({
  buttonLeftClick,
  buttonRightClick,
  className,
  ...props
}) => {
  const buttonLeft = (
    <Button2 onPress={buttonLeftClick} variant="secondary">
      Yes, Reconnect Me Now
    </Button2>
  );

  const buttonRight = <Button2 onPress={buttonRightClick}>No, My Session is Done</Button2>;

  return (
    <TwoButtonCard
      buttonLeft={buttonLeft}
      buttonRight={buttonRight}
      className={cn("apti-GuidedSessionReconnect", className)}
      {...props}
    >
      <div className="text-center apti-TwoButtonCard-title">
        <Text className="apti-TwoButtonCard-title-font" color="grey">
          Hmm, it looks like your session ended. Do you need to reconnect?
        </Text>
      </div>
    </TwoButtonCard>
  );
};

GuidedSessionReconnect.propTypes = {
  buttonLeftClick: PropTypes.func,
  buttonRightClick: PropTypes.func,
  className: PropTypes.string,
};

GuidedSessionReconnect.defaultProps = {
  buttonLeftClick: () => {},
  buttonRightClick: () => {},
  className: undefined,
};
